var TEMPLATE_URL = require('./credit.card.view.html');

angular.module('ikeweb.user').directive('creditCardView', [

    function() {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: TEMPLATE_URL,
            scope: {
                card: '=card',
                showUpdate: '=',
                openUpdate: '&',
                toggle: '='
            }
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/credit.card.view.directive.js
// module id = 484
// module chunks = 0